"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var clsx_1 = __importDefault(require("clsx"));
var Typography_1 = __importDefault(require("../Typography"));
var SvgClose_1 = __importDefault(require("../Icon/SvgClose"));
var ButtonIcon_1 = __importDefault(require("../Button/ButtonIcon"));
var Polished_1 = require("../utils/Polished");
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var PopupTitleSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  flex: 0 0 auto;\n  min-height: ", ";\n  display: flex;\n  align-items: center;\n\n  ._ndsPopupTitle__text {\n    align-self: flex-start;\n    margin-top: ", ";\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: auto;\n  }\n  ._ndsPopupTitle__close {\n    align-self: flex-start;\n    margin-right: ", ";\n    min-width: ", ";\n  }\n  ._ndsPopupTitle__close--dark-mode {\n    cursor: pointer;\n  }\n"], ["\n  padding: 0;\n  flex: 0 0 auto;\n  min-height: ", ";\n  display: flex;\n  align-items: center;\n\n  ._ndsPopupTitle__text {\n    align-self: flex-start;\n    margin-top: ", ";\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: auto;\n  }\n  ._ndsPopupTitle__close {\n    align-self: flex-start;\n    margin-right: ", ";\n    min-width: ", ";\n  }\n  ._ndsPopupTitle__close--dark-mode {\n    cursor: pointer;\n  }\n"])), Polished_1.rem('32px'), Polished_1.rem('4px'), Polished_1.rem('-4px'), Polished_1.rem('32px'));
var PopupTitle = function (props) {
    var children = props.children, forwardedRef = props.forwardedRef, onClose = props.onClose, classNameProp = props.className, responsive = props.responsive, darkMode = props.darkMode, others = __rest(props, ["children", "forwardedRef", "onClose", "className", "responsive", "darkMode"]);
    var hasCloseAction = typeof onClose === 'function';
    var renderChildren = react_1.default.useMemo(function () {
        return responsive ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.default, __assign({ variant: "h5", className: "ndsHidden-s-up" }, (darkMode && { mode: 'dark' })), children),
            react_1.default.createElement(Typography_1.default, __assign({ variant: "h3", className: "ndsHidden-xs-down" }, (darkMode && { mode: 'dark' })), children))) : (react_1.default.createElement(Typography_1.default, __assign({ variant: "h6", className: "_ndsPopupTitle__text" }, (darkMode && { mode: 'dark' })), children));
    }, [responsive, children, darkMode]);
    if (children) {
        return (react_1.default.createElement(PopupTitleSC, __assign({ ref: forwardedRef, className: clsx_1.default(classNameProp, '_ndsPopupTitle', {
                '_ndsPopupTitle--with-close': hasCloseAction
            }) }, others),
            renderChildren,
            hasCloseAction && !darkMode && (react_1.default.createElement(ButtonIcon_1.default, __assign({ onClick: onClose, className: "_ndsPopupTitle__close" }, (!darkMode && { color: 'grey' }), { compact: true }),
                react_1.default.createElement(SvgClose_1.default, null))),
            hasCloseAction && darkMode && (react_1.default.createElement(SvgClose_1.default, { onClick: onClose, className: "_ndsPopupTitle__close--dark-mode", color: "#ffffff" }))));
    }
    return null;
};
PopupTitle.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    forwardedRef: prop_types_1.default.any,
    onClose: prop_types_1.default.func,
    className: prop_types_1.default.string,
    responsive: prop_types_1.default.bool,
    darkMode: prop_types_1.default.bool
};
PopupTitle.defaultProps = {
    children: null,
    forwardedRef: react_1.default.createRef(),
    onClose: null,
    className: undefined,
    responsive: false,
    darkMode: false
};
exports.default = reactHelpers_1.withForwardedRef(PopupTitle);
var templateObject_1;
//# sourceMappingURL=PopupTitle.js.map